import y from "./contact-channels78.js";
function r(t) {
  "@babel/helpers - typeof";
  return r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, r(t);
}
function u(t, e) {
  y(t);
  var o, n;
  r(e) === "object" ? (o = e.min || 0, n = e.max) : (o = arguments[1], n = arguments[2]);
  var f = encodeURI(t).split(/%..|./).length - 1;
  return f >= o && (typeof n > "u" || f <= n);
}
export {
  u as default
};
//# sourceMappingURL=contact-channels83.js.map
